import { useEffect, useState } from "react";
import { MonsterDto } from "../../../Types/ApiTypes";
import { getTranslation } from "../../../Utils/Converters";
import MonsterModal from "./MonsterModal";
import { addMonster, deleteMonster } from "../../../Utils/LocalApi";

interface MonsterRowItemComponentProps{
    monster: MonsterDto,
    deleteMonster: (id?: number) => void
}


const MonsterRowItemComponent = (props: MonsterRowItemComponentProps)=>{
    const [monster, setMonster] = useState({} as MonsterDto);
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        setMonster(props.monster);
    },[props.monster])

    return(
        <>
            <tr>
                <td>{monster.id}</td>
                <td>{monster.source ? (monster.source.year > 0 ? monster.source.year+" " : "")+getTranslation(monster.source.name) : ""}</td>
                {/* <td>{monster.index}</td> */}
                <td>{monster.name ? getTranslation(monster.name) : ""}</td>
                {/* <td>{monster.school ? getTranslation(monster.school) : ""}</td> */}
                {/* <td className="text-center">
                    <span>
                        <input 
                            name="reaction" 
                            type="checkbox"
                            className='form-check-input'
                            style={{maxWidth: "24px", maxHeight: "24px", outlineStyle:"auto", outlineColor: "darkgray"}}
                            checked={monster.concentration}
                            disabled
                        ></input>
                    </span>
                </td>
                <td>{monster.classes ? getTranslation(monster.classes) : ""}</td>
                <td>{monster.castingTime ? getTranslation(monster.castingTime) : ""}</td> */}
                <td>
                    <span role="button"
                        onClick={(e => {
                            setIsModalOpen(true);
                        })}
                    >
                        <i className="bi bi-pencil-square"></i>
                    </span>
                     &nbsp;
                    <span role="button"
                        onClick={(e => {
                            let newMonster = structuredClone(monster);
                            delete newMonster.id;
                            addMonster(newMonster).then((result) => {
                                console.log(result);
                            });
                        })}
                    >
                        <i className="bi bi-copy"></i>
                    </span>
                     &nbsp;
                    <span role="button"
                        onClick={(e => {
                            let id = props.monster.id;
                            if (id) {
                                deleteMonster(id).then((result) => {
                                    if (result >= 200 && result < 300){
                                        props.deleteMonster(id)
                                    }
                                });
                            }
                        })}
                    >
                        <i className="bi bi-trash"></i>
                    </span>
                    {isModalOpen && 
                    <MonsterModal
                        monster={monster}
                        updateMonster={setMonster}
                        deleteMonster={(id?: number)=>{props.deleteMonster(id)}}
                        closeModal={()=>{setIsModalOpen(false)}}
                    />}
                </td>
            </tr>
            
        </>
    )
}
export default MonsterRowItemComponent;